export default ({ targetRect, layerRect }) =>
    targetRect.top < layerRect.top ||
    targetRect.right > layerRect.right ||
    targetRect.bottom > layerRect.bottom ||
    targetRect.left < layerRect.left;
